$(function(){
	
	//top bar bg animation
	$(window).scroll(function() {
	    if ($(this).scrollTop() > 0) {
	        $(".fixed").addClass(" bg");	
	    } else {
	    	$(".fixed").removeClass("bg");	
	    }


	    if ($(this).scrollTop() > 600) {
			$('.scrollToTop').fadeIn();
		} else {
			$('.scrollToTop').fadeOut();
		}	
	});
	
	$('.scrollToTop').click(function(){
		$('html, body').animate({scrollTop : 0},800);
		return false;
	});


	//lang switcher
	$(".lang-menu").bind('click tap', function(event) {
		$(this).children(".hide").slideToggle(400);
	});

	//flag hover
	$('.flag-hover li a').hover(function(event) {
	  	var id = $(this).attr("name");
	  	var elem = $("#" + id).toggleClass(" hover");
	});

	/*$('.home .top-bar-section ul > li > a[data-anchor]').bind("tap click", function(e){
    	e.preventDefault();
    	var obj = "#" + $(this).data('anchorid');

    	if(obj.indexOf('#') == 0) {
	    	$('a[data-anchor]').removeClass("active");
	    	$(obj).animateScroll();    	
	    	$(this).addClass(" active");
	    }
    });*/

    
    $("#hidemap").unbind().bind("click tap", function(){
		$(this)
			.hide()
			.next()
			.fadeIn();
		$("#mapiframe").slideUp(400);
		$("#form-wrapper").slideDown(200);

		return false;
	});

    $("#showmap").unbind().bind("click tap", function(){
		$(this)
			.hide()
			.prev()
			.fadeIn();
		$("#form-wrapper").slideUp(400);
		$("#mapiframe").slideDown(400);

		return false;
	});
	

});
	  	
